<script setup>
import { Handle, Position, useNode } from '@vue-flow/core';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useNodeAudience } from '../../composables/useNodeAudience.js';

const props = defineProps({
  data: { type: Object, default: () => ({}) },
  selected: { type: Boolean, default: false },
});

const { t } = useI18n();
const { id } = useNode();
const audienceCount = useNodeAudience(id);

const conditionsCount = computed(() => (props.data.conditions ?? []).length);
</script>

<template>
  <div
    class="flow-node min-w-[160px] max-w-[200px] rounded-xl overflow-hidden shadow-md border-2 transition-all"
    :class="selected ? 'border-orange-400' : 'border-transparent'"
  >
    <Handle type="target" :position="Position.Top" />
    <div class="flex items-center gap-2 px-3 py-2 bg-orange-500 text-white">
      <span class="i-lucide-filter size-4 shrink-0" />
      <span class="text-xs font-semibold truncate flex-1">{{ data.name || t('FLOW_BUILDER.NODES.FILTER_ARRAY.TITLE') }}</span>
      <span v-if="audienceCount !== null" class="text-[9px] bg-white/20 rounded-full px-1.5 py-0.5 font-medium tabular-nums shrink-0">
        {{ audienceCount }}
      </span>
    </div>
    <div class="px-3 py-2 bg-n-solid-1 text-xs text-n-slate-10">
      <span class="truncate block">{{ data.variable_name || t('FLOW_BUILDER.NODES.FILTER_ARRAY.UNDEFINED_VARIABLE') }}</span>
      <span class="text-[10px] text-n-slate-9">{{ t('FLOW_BUILDER.NODES.FILTER_ARRAY.CONDITIONS_COUNT', conditionsCount) }}</span>
    </div>
    <Handle type="source" :position="Position.Bottom" />
  </div>
</template>
